import React, { useEffect, useState } from 'react';

const RankUpModal = ({ rankName, rankKey, gender, onClose }) => {
  const [show, setShow] = useState(false);
  const spriteUrl = `/sprites/${rankKey}_${gender || 'male'}.png`;

  useEffect(() => {
    setTimeout(() => setShow(true), 100);
  }, []);

  const handleClose = () => {
    setShow(false);
    setTimeout(onClose, 300);
  };

  return (
    <div 
      className={`fixed inset-0 z-[100] flex items-center justify-center transition-all duration-300 ${
        show ? 'opacity-100' : 'opacity-0'
      }`}
      data-testid="rank-up-modal"
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
      
      {/* Content */}
      <div className={`relative z-10 text-center transition-transform duration-500 ${
        show ? 'scale-100' : 'scale-50'
      }`}>
        {/* Sparkle particles */}
        <div className="absolute inset-0 -m-16 pointer-events-none">
          {[...Array(12)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 rounded-full"
              style={{
                background: i % 3 === 0 ? '#FFD700' : i % 3 === 1 ? '#38bdf8' : '#fff',
                top: `${20 + Math.random() * 60}%`,
                left: `${10 + Math.random() * 80}%`,
                animation: `sparkle ${1 + Math.random()}s ease-in-out ${Math.random() * 0.5}s infinite alternate`,
              }}
            ></div>
          ))}
        </div>

        {/* Evolution text */}
        <div className="mb-4">
          <p className="text-sky-400 text-sm font-bold tracking-[0.3em] uppercase animate-pulse">
            Evolución Desbloqueada
          </p>
        </div>

        {/* Character sprite */}
        <div className="relative mx-auto w-40 h-48 mb-4">
          <div className="absolute inset-0 bg-sky-400/20 rounded-full blur-2xl animate-pulse"></div>
          <img
            src={spriteUrl}
            alt={rankName}
            className="relative w-full h-full object-contain drop-shadow-2xl"
            style={{ 
              animation: 'floatUp 2s ease-in-out infinite alternate',
              filter: 'drop-shadow(0 0 20px rgba(56, 189, 248, 0.5))'
            }}
            data-testid="rankup-sprite"
          />
        </div>

        {/* Rank name */}
        <h2 className="text-2xl font-bold text-white mb-2">{rankName}</h2>
        <p className="text-gray-300 text-sm mb-6">¡Has alcanzado un nuevo rango!</p>

        {/* Continue button */}
        <button
          onClick={handleClose}
          data-testid="rankup-continue-btn"
          className="px-8 py-2.5 bg-sky-500 text-white font-semibold rounded-full hover:bg-sky-400 transition-colors shadow-lg shadow-sky-500/30"
        >
          Continuar
        </button>
      </div>

      <style>{`
        @keyframes sparkle {
          0% { transform: scale(0) rotate(0deg); opacity: 0; }
          100% { transform: scale(1) rotate(180deg); opacity: 1; }
        }
        @keyframes floatUp {
          0% { transform: translateY(5px); }
          100% { transform: translateY(-5px); }
        }
      `}</style>
    </div>
  );
};

export default RankUpModal;
